import {Injectable} from '@angular/core';
import {FormattedNumber} from '@components/ui/table-template/classes/formatted-number';
import {EntityAssetListDto} from '@dto/holdings/entity-asset-list.dto';
import {EntityAssetDto} from '@dto/holdings/entity-asset.dto';
import {EntityAssetViewModel} from '../view-models/entity-asset.view-model';

@Injectable({
  providedIn: 'root'
})
export class EntityAssetConverterService {

  public convert(entityCode: string, entityAssetList: EntityAssetListDto): EntityAssetViewModel[] {
    return entityAssetList.entityAssets.map(entityAsset => this.convertSingle(entityCode, entityAsset));
  }

  private convertSingle(entityCode: string, entityAsset: EntityAssetDto): EntityAssetViewModel {
    return {
      entityCode: entityCode,
      id: entityAsset.id,
      name: entityAsset.name,
      type: entityAsset.type,
      bookValue: new FormattedNumber(entityAsset.bookValue),
      bookValueCurrency: entityAsset.bookValueCurrency,
      marketValue: new FormattedNumber(entityAsset.marketValue),
      marketValueCurrency: entityAsset.marketValueCurrency,
      marketValueDate: entityAsset.marketValueDate ? new Date(entityAsset.marketValueDate) : null,
      portfolioNumber: entityAsset.portfolioNumber
    };
  }
}
